import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';
import { ProposalService } from './proposal.service';

@Injectable({
    providedIn: 'root'
})
export class PurchasedSalesPackageService implements Resolve<any> {



    constructor(
        private api: ApiService,
        private router: Router,
        private proposalService: ProposalService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            const resolved: any = {};
            if (state.url.includes('payment-success')) {
                const token = route.queryParams.token;
                const payerId = route.queryParams.PayerID;
                if (token && payerId) {
                    const respo: any = await this.paypalSuccess(token, payerId);
                    resolved.purchasedSalesPackage = respo.payload;
                } else {
                    const purchasedSalesPackageId =
                        route.queryParams.purchasedSalesPackageId;
                    const respo: any = await this.getPayedPurchasedSalesPackage(
                        purchasedSalesPackageId
                    );
                    resolved.purchasedSalesPackage = respo.payload;
                }
            } else if (state.url.includes('payment-cancel')) {
                const token = route.queryParams.token;
                if (token) {
                    const respo: any = await this.paypalCancel(token);
                    resolved.purchasedSalesPackage = respo.payload;
                }
            } else if ((state.url.includes('common-area') && state.url.includes('courses/') && state.url.includes('/proposals'))) {
                const purchasedSalesPackageId = route.params.purchasedSalesPackageId;
                const respo: any = await this.getPurchasedSalesPackage(
                    purchasedSalesPackageId
                );
                resolved.purchasedSalesPackage = respo.payload;
                if (route.queryParams.proposalId) {
                    const respo2: any = await this.proposalService.getProposal(
                        route.queryParams.proposalId
                    );
                    resolved.proposal = respo2.payload;
                    resolved.openViewProposalModal = route.queryParams.openViewProposalModal;
                    resolved.openManageProposalModal = route.queryParams.openManageProposalModal;
                }
            } else {
                const purchasedSalesPackageId = route.queryParams.purchasedSalesPackageId;
                if (purchasedSalesPackageId) {
                    const respo: any = await this.getPurchasedSalesPackage(
                        purchasedSalesPackageId
                    );
                    resolved.purchasedSalesPackage = respo.payload;
                    const openViewEstimationModal = route.queryParams.openViewEstimationModal;
                    if (openViewEstimationModal) {
                        resolved.openViewEstimationModal = openViewEstimationModal;
                    }
                }
            }
            return resolved;
        } catch (err) {
            this.router.navigateByUrl(``);
        }
    }

    async startLesson(purchasedSalesPackageId, checkVideoLesson?) {
        let url = `purchasedsalespackage/${purchasedSalesPackageId}/startLesson`;
        if (checkVideoLesson) {
            url += `?checkVideoLesson=${checkVideoLesson}`;
        }
        return this.api.postRequestPromise(url, {});
    }

    async getListByCurrentUserLogged() {
        return this.api.getRequestPromise(
            `purchasedsalespackage/byCurrentUserLogged`
        );
    }

    async getListInSignificantEventsByCurrentUserLogged() {
        return this.api.getRequestPromise(
            `purchasedsalespackage/inSignificantEventsByCurrentUserLogged`
        );
    }

    async getList(filterStatus, fromValue, toValue, pageIndex, pageSize) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/byFilters?filterStatus=${filterStatus}&from=${fromValue}&to=${toValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`
        );
    }

    async createPurchasedSalesPackage(obj) {
        return this.api.postRequestPromise(`purchasedsalespackage/create`, obj);
    }

    async setToPayedWithBankTransfer(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/setToPayedWithBankTransfer`,
            {}
        );
    }

    async payPurchasedSalesPackageWithBankTransfer(
        purchasedSalesPackageId,
        credit,
        useCredit
    ) {
        let url = `purchasedsalespackage/${purchasedSalesPackageId}/payPurchasedSalesPackageWithBankTransfer`;
        if (useCredit) {
            if (credit) {
                url += `?credit=${credit}`;
            }
        }
        return this.api.putRequestPromise(url, {});
    }

    async payPurchasedSalesPackageWithPayPal(
        purchasedSalesPackageId,
        credit,
        useCredit
    ) {
        let url = `purchasedsalespackage/${purchasedSalesPackageId}/payPurchasedSalesPackageWithPayPal`;
        if (useCredit) {
            if (credit) {
                url += `?credit=${credit}`;
            }
        }
        return this.api.putRequestPromise(url, {});
    }

    async refundPayPal(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/refundPayPalPurchasedSalesPackage`,
            {}
        );
    }

    async refundBankTransfer(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/refundBankTransferPurchasedSalesPackage`,
            {}
        );
    }

    async paypalCancel(token) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/cancelPayPalPurchasedSalesPackage?token=${token}`
        );
    }

    async paypalSuccess(token, payerId) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/authorizeAndCapturePayPalPurchasedSalesPackage?token=${token}&PayerID=${payerId}`
        );
    }

    async getPayedPurchasedSalesPackage(purchasedSalesPackageId) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/payed/${purchasedSalesPackageId}`
        );
    }

    async getPurchasedSalesPackage(purchasedSalesPackageId) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}`
        );
    }

    async setToWaitingForPayment(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/setToWaitForPayment`,
            {}
        );
    }

    async setToCancelledByProfessor(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/setToCancelledByProfessor`,
            {}
        );
    }
    async getProfessorRankingAndCountPurchasedSalesPackage() {
        return this.api.getRequestPromise(
            'purchasedsalespackage/getProfessorRankingAndCountPurchasedSalesPackagesPayedOrActiveOrCompleted'
        );
    }

    async getPurchasedSalesPackages() {
        return this.api.getRequestPromise(`public/purchasedSalesPackages`);
    }

    async getStudentRequestsByStudentBestMatchRequestId(
        studentBestMatchRequestId
    ) {
        return this.api.getRequestPromise(
            `agenda/bestMatch/studentRequests/${studentBestMatchRequestId}`
        );
    }

    async cancelPurchasedSalesPackage(purchasedSalesPackageId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/cancelPurchasedSalesPackage`,
            {}
        );
    }

    async editPayent(payment) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${payment.id}`,
            payment
        );
    }

    async newPayent(payment) {
        return this.api.postRequestPromise(`purchasedsalespackage`, payment);
    }

    async deletePayment(paymentId) {
        return this.api.deleteRequestPromise(
            `purchasedsalespackage/${paymentId}`
        );
    }

    async getFilteredPurchasedSalesPackage(
        pageIndex,
        pageSize,
        selectedStatus
    ) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/byFilters?pageIndex=${pageIndex}&pageSize=${pageSize}&selectedStatus=${selectedStatus}`
        );
    }

    async uploadBill(purchasedSalesPackageId, billId) {
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/setBill/${billId}`,
            {}
        );
    }

    async deleteBill(purchasedSalesPackageId, billId) {
        return this.api.deleteRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/files/${billId}/delete`
        );
    }

    async getByProfessorPurchasedSalesPackageActiveOrCompletedByAdmin(
        pageIndex,
        pageSize
    ) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/getProfessorCardDetailedByAdmin?pageIndex=${pageIndex}&pageSize=${pageSize}`
        );
    }

    async getByStudentPurchasedSalesPackageActiveOrCompletedByAdmin(
        pageIndex,
        pageSize
    ) {
        return this.api.getRequestPromise(
            `purchasedsalespackage/getStudentCardDetailedByAdmin?pageIndex=${pageIndex}&pageSize=${pageSize}`
        );
    }

    // START OK
    async getProfessorCard(fromDate, toDate) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getProfessorCard?fromDate=${fromDate}&toDate=${toDate}`;
        } else {
            url = `purchasedsalespackage/getProfessorCard`;
        }
        return this.api.getRequestPromise(url);
    }

    async getProfessorPurchasedSalesPackages(
        fromDate,
        toDate,
        pageIndex,
        pageSize
    ) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getProfessorPurchasedSalesPackages?startDate=${fromDate}&endDate=${toDate}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        } else {
            url = `purchasedsalespackage/getProfessorPurchasedSalesPackages?pageIndex=${pageIndex}&pageSize=${pageSize}`;
        }
        return this.api.getRequestPromise(url);
    }

    async getStudentCard(fromDate, toDate) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getStudentCard?fromDate=${fromDate}&toDate=${toDate}`;
        } else {
            url = `purchasedsalespackage/getStudentCard`;
        }
        return this.api.getRequestPromise(url);
    }

    async getStudentPurchasedSalesPackages(
        fromDate,
        toDate,
        pageIndex,
        pageSize
    ) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getStudentPurchasedSalesPackages?startDate=${fromDate}&endDate=${toDate}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        } else {
            url = `purchasedsalespackage/getStudentPurchasedSalesPackages?pageIndex=${pageIndex}&pageSize=${pageSize}`;
        }
        return this.api.getRequestPromise(url);
    }
    // END OK
    async getProfessorCardByAdmin(userInfoId, fromDate, toDate) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getProfessorCardByAdmin?userInfoId=${userInfoId}&fromDate=${fromDate}&toDate=${toDate}`;
        } else {
            url = `purchasedsalespackage/getProfessorCardByAdmin?userInfoId=${userInfoId}`;
        }
        return this.api.getRequestPromise(url);
    }
    async getStudentCardByAdmin(userInfoId, fromDate, toDate) {
        let url;
        if (fromDate && toDate) {
            url = `purchasedsalespackage/getStudentCardByAdmin?userInfoId=${userInfoId}&fromDate=${fromDate}&toDate=${toDate}`;
        } else {
            url = `purchasedsalespackage/getStudentCardByAdmin?userInfoId=${userInfoId}`;
        }
        return this.api.getRequestPromise(url);
    }

    async getProfessorPurchasedSalesPackagesByAdmin(
        userInfoId,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    ) {
        let url;
        if (fromDate && toDate) {
            // tslint:disable-next-line:max-line-length
            url = `purchasedsalespackage/getProfessorPurchasedSalesPackagesByAdmin?userInfoId=${userInfoId}&startDate=${fromDate}&endDate=${toDate}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        } else {
            url = `purchasedsalespackage/getProfessorPurchasedSalesPackagesByAdmin?userInfoId=${userInfoId}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        }
        return this.api.getRequestPromise(url);
    }

    async getStudentPurchasedSalesPackagesByAdmin(
        userInfoId,
        fromDate,
        toDate,
        pageIndex,
        pageSize
    ) {
        let url;
        if (fromDate && toDate) {
            // tslint:disable-next-line:max-line-length
            url = `purchasedsalespackage/getStudentPurchasedSalesPackagesByAdmin?userInfoId=${userInfoId}&startDate=${fromDate}&endDate=${toDate}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        } else {
            url = `purchasedsalespackage/getStudentPurchasedSalesPackagesByAdmin?userInfoId=${userInfoId}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
        }
        return this.api.getRequestPromise(url);
    }

    async getPurchasedSalesPackageLogEvents(
        purchasedSalesPackageId,
        startDate,
        endDate,
        pageIndex,
        pageSize
    ) {
        // tslint:disable-next-line:max-line-length
        return this.api.getRequestPromise(
            // tslint:disable-next-line:max-line-length
            `purchasedsalespackage/getApplicationLogActions?purchasedSalesPackageId=${purchasedSalesPackageId}&startDate=${startDate}&endDate=${endDate}&pageIndex=${pageIndex}&pageSize=${pageSize}`
        );
    }

    async cancelPurchasedSalesPackageByAdministration(purchasedSalesPackageId) {
        // tslint:disable-next-line:max-line-length
        return this.api.putRequestPromise(
            `purchasedsalespackage/${purchasedSalesPackageId}/cancelPurchasedSalesPackageByAdministration`,
            {}
        );
    }

    async estimation(purchasedSalesPackageId, estimation) {
        return this.api.postRequestPromise(`purchasedsalespackage/${purchasedSalesPackageId}/estimation`, estimation);
    }
}
